import { isPremium } from "../../common/utils"
export const PremiumCheck = date => isPremium(date)
